module.exports = __webpack_public_path__ + "static/img/anxun3.43598bd0.png";